declare var API: { cartChange: string };

import formatPriceShort from '../helpers/formatPriceShort';

const $cart: any = $('.js-cart');
const $total: any = $('[data-cart="total"]');

const ROW_SELECTOR: string = '[data-cart-product="product"]';
const ROW_TOTAL_SELECTOR: string = '[data-cart-product="total"]';
const ROW_QUANTITY_SELECTOR: string = '[data-cart-product="quantity"]';
const ROW_DELETE_SELECTOR: string = '[data-cart-product="delete"]';

const cart = {
  initialize() {
    if ($cart.length) {
      this.getItems = () => { this.items = $('[data-cart-product="product"]').toArray(); };
      this.getItems();

      this.createEvents();
    }
  },

  /**
   * Hook up all events for the cart
   * @return {void}
   */
  createEvents() {
    $cart.on('change', ROW_QUANTITY_SELECTOR, (e: any) => {
      const $row: any = this.getCartRow($(e.currentTarget));

      this.recalculateRow($row);
      this.recalculateTotals();
    });

    $cart.on('click', ROW_DELETE_SELECTOR, (e: any) => {
      const $row: any = this.getCartRow($(e.currentTarget));

      this.hideRow($row)
        .then(this.removeRow.bind(this))
        .then(this.recalculateTotals.bind(this));
    });
  },

  /**
   * Retrieve the parent cart row for given element
   * @param {Object} $el jQuery element
   * @return {Object} Cart row
   */
  getCartRow($el: any) {
    return $el.parents(ROW_SELECTOR);
  },

  /**
   * Get price per piece for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} fallback
   * @return {Number}
   */
  getPriceForRow($row: any, fallback: number = 0) {
    const $quantity: any = $row.find('[data-cart-product="quantity"]');

    if ($quantity[0].tagName === 'SELECT') {
      return parseFloat($quantity.find('option:selected').data('price'));
    }

    const quantity = parseInt($quantity.val(), 10);
    const price = parseFloat($quantity.data('price'));

    return (Number.isNaN(quantity) ? fallback : quantity * price);
  },

  /**
   * Get quantity of the product row
   * @param {Object} $row jQuery element of the product row
   * @param {String|Number} fallback Fallback for when the value is not a number
   * @return {Number}
   */
  getQuantityForRow($row: any, fallback: number = 1) {
    const $quantity: any = $row.find('[data-cart-product="quantity"]');

    let quantity;

    if ($quantity[0].tagName === 'SELECT') {
      quantity = parseInt($quantity.find('option:selected').val(), 10);
    } else {
      quantity = parseInt($quantity.val(), 10);
    }

    return (Number.isNaN(quantity)) ? fallback : quantity;
  },

  /**
   * Output the total price for the row
   * @param {Object} $row jQuery element of the product row
   * @param {Number} total Total price
   * @return {void}
   */
  outputRowTotal($row: any, total: number) {
    $row
      .data('total', total)
      .find(ROW_TOTAL_SELECTOR)
      .html(formatPriceShort(total));
  },

  /**
   * Recalculate the total of the product row
   * @param {Object} $row jQuery element of the product row
   * @return {void}
   */
  recalculateRow($row: any) {
    const total: number = this.getPriceForRow($row);
    const quantity: number = this.getQuantityForRow($row);

    this.cartChange($row.data('id'), quantity);
    this.outputRowTotal($row, total);
  },

  /**
   * Calculate the cart total and output
   * @return {void}
   */
  recalculateTotals() {
    this.getItems();

    const total: number = this.items.reduce((acc: number, item: HTMLElement) => {
      const priceTotal = this.getPriceForRow($(item));
      return acc + priceTotal;
    }, 0);

    $total.html(formatPriceShort(total));

    $(document).trigger('cart:change', total);
  },

  /**
   * Hide the row visually
   * @param {Object} $row jQuery element of the row
   * @return {Promise}
   */
  hideRow($row: any) {
    return new Promise((resolve: Function) => {
      // Fade the product out and resolve the promise on completion
      $row.animate({
        transform: 'translate3d(-15px, 0, 0)',
        opacity: 0,
      }, { duration: 400, done: () => resolve($row) });
    });
  },

  /**
   * Remove the row from the DOM
   * @param {Object} $row jQuery element of the row
   * @return {Promise}
   */
  removeRow($row: any) {
    return new Promise((resolve: Function) => {
      // Create a replacement div that will keep the space
      const $replacement: any = $('<div />');
      $replacement.css('height', $row.outerHeight(true));

      // Add the replacement div
      $row.before($replacement);

      // Remove the product row
      $row.remove();

      this.cartChange($row.data('id'), 0);

      // Animate the replacement div to hide it slowly
      $replacement.animate({
        height: 0,
      }, {
        duration: 400,
        done: () => {
          // Remove the last traces of the product removal
          $replacement.remove();
          resolve();
        },
      });
    });
  },

  /**
   * Call API with cart changes
   * @param {Number} id
   * @param {Number} quantity
   * @return {void}
   */
  cartChange(id: number, quantity: number) {
    $.ajax({
      url: `${API.cartChange}/${id}`,
      type: 'POST',
      data: {
        quantity,
        _method: 'put',
      },
    });
  },
};

export default cart;

